<template>
  <div id="header">
    <div id="nav" class="navbar-wrapper">
      <nav
        role="navigation"
        class="navbar navbar-default"
        :class="$route.path == '/' && scrollY <= 0 ? 'homeNavbar' : ''"
      >
        <div class="navbar-header">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar"
            class="navbar-toggle collapsed"
          >
            <span class="sr-only"></span> <span class="icon-bar"></span>
            <span class="icon-bar"></span> <span class="icon-bar"></span>
          </button>
          <a href="/"><img src="@/assets/logo.svg" alt="logo" id="logo"/></a>
        </div>
        <div
          id="navbar"
          :class="$route.path == '/' && scrollY <= 0 ? 'homeNavbar' : ''"
          class="navbar-collapse collapse"
        >
          <ul class="bar nav navbar-nav navbar-right">
            <li class="item common">
              <a href="/" :class="{ active: $route.name == 'home' }">Home</a>
            </li>
            <li class="item common">
              <a href="/tech" :class="{ active: $route.name == 'tech' }"
                >Technical Advantages</a
              >
            </li>
            <li class="item common">
              <a
                href="/product"
                :class="{
                  active: $route.name == 'product' || $route.name == 'hmo'
                }"
                >Products and Services</a
              >
            </li>
            <li class="item common">
              <a href="/about" :class="{ active: $route.name == 'about' }"
                >About us</a
              >
            </li>
            <li class="item common">
              <a
                href="/news"
                :class="{
                  active: $route.name == 'news' || $route.name == 'newsDetail'
                }"
                >Conpany News</a
              >
            </li>
            <li class="item common">
              <a href="/join" :class="{ active: $route.name == 'join' }"
                >Join Us</a
              >
            </li>
            <li role="presentation" class="dropdown">
              <a
                class="dropdown-toggle"
                data-toggle="dropdown"
                href="#"
                aria-haspopup="true"
                aria-expanded="false"
              >
                English <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a @click.prevent="jumpCN">中文</a>
                </li>
                <li><a @click.prevent="jumpEN">English</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      scrollY: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", e => {
      this.scrollY =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
    });
  },
  methods: {
    jumpCN() {
      location.href = `https://www.yixilife.com`;
    },
    jumpEN() {
      location.href = `https://en.yixilife.com`;
    }
  }
};
</script>

<style>
#navbar li a {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue